"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalise = void 0;
var capitalise = function (text) {
    return text.charAt(0).toUpperCase() + text.substring(1);
};
exports.capitalise = capitalise;
